import { render, staticRenderFns } from "./Refact.vue?vue&type=template&id=bba167fe"
import script from "./Refact.vue?vue&type=script&lang=js"
export * from "./Refact.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports